import * as React from "react";

export default () => {
  return <div>Fyll i information kring när betalningen gjordes av datumen den avsåg</div>;
};
